import "@assets/css/bootstrap-grid.css";
import React from "react";
import HomeCherishMomentForm from "./cherish-moment.form";

const CherishMomentForm: React.FC = () => {
  return (
    <>
      <HomeCherishMomentForm />
    </>
  );
};

export default CherishMomentForm;
